{
  "tree": {
    "base": {
      "listStyle": "none",
      "backgroundColor": "transparent",
      "margin": 0,
      "padding": 0,
      "color": "#111212",
      "fontFamily": "Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif",
      "fontSize": "1.4rem",
      "fontWeight": "300"
    },
    "node": {
      "base": {
        "position": "relative",
        "margin": "0"
      },
      "link": {
        "cursor": "pointer",
        "position": "relative",
        "padding": "0",
        "display": "flex",
        "alignItems": "center",
        "minHeight": "32px",
        "borderRadius": "4px",
        "transition": "background 200ms ease-in-out"
      },
      "activeLink": {
        "fontWeight": "400"
      },
      "toggle": {
        "base": {
          "position": "relative",
          "display": "inline-block",
          "verticalAlign": "top",
          "marginLeft": "-5px",
          "height": "24px",
          "width": "24px"
        },
        "wrapper": {
          "position": "absolute",
          "top": "50%",
          "left": "50%",
          "margin": "-7px 0 0 -7px",
          "height": "14px"
        },
        "height": 14,
        "width": 14,
        "arrow": {
          "fill": "#9DA5AB",
          "strokeWidth": 0
        }
      },
      "header": {},
      "subtree": {
        "listStyle": "none",
        "paddingLeft": "16px"
      },
      "loading": {
        "color": "#E2C089"
      }
    }
  }
}
